import {
	TRIGGER_TXN_STATUS_API_CALL_SUCCESS,
	TRIGGER_REPAYMENT_STATUS_API_CALL_SUCCESS,
	TRIGGER_CLEAR_TXN_DETAILS,
} from 'redux/actionTypes';

const initialState = {};

// export const locale[];

const TxnStatusReducer = (state = initialState, action) => {
	switch (action.type) {
		case TRIGGER_TXN_STATUS_API_CALL_SUCCESS:
		case TRIGGER_REPAYMENT_STATUS_API_CALL_SUCCESS:
			return {
				...state,
				...action.data,
			};

		case TRIGGER_CLEAR_TXN_DETAILS:
			return {};
		default:
			return state;
	}
};

export default TxnStatusReducer;
